import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Star = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="star icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      clipRule="evenodd"
      fillRule="evenodd"
      d="M19.797 54.978c-1.43 1.086-2.628 1.351-3.574.58-.945-.749-1.152-1.979-.576-3.74l4.818-15.005-12.31-9.264c-1.43-1.061-2.03-2.171-1.638-3.377.37-1.158 1.453-1.737 3.228-1.713l15.1.096 4.589-15.077c.553-1.785 1.383-2.678 2.559-2.678 1.199 0 2.029.893 2.582 2.678l4.588 15.077 15.1-.096c1.776-.024 2.86.555 3.228 1.713.37 1.206-.208 2.316-1.637 3.377l-12.31 9.264 4.818 15.005c.576 1.761.368 2.991-.577 3.74-.968.771-2.144.506-3.573-.58l-12.22-9.384-12.195 9.384Zm25.089-3.517L31.99 41.558l-12.868 9.9 5.085-15.834-13.233-9.957 16.237.104 4.792-15.749 4.792 15.749 16.238-.104L39.8 35.624l5.085 15.837Z"
    />
    <path
      className={`color-iconPrimary-disabled ${pathClass}`}
      d="M30.569 54.062c.59-1.18 2.272-1.18 2.862 0l3.811 7.623A1.6 1.6 0 0 1 35.811 64h-7.622a1.6 1.6 0 0 1-1.431-2.316l3.81-7.622ZM52.54 40.179c-.94-.926-.42-2.526.885-2.723l8.427-1.269a1.6 1.6 0 0 1 1.76 2.077l-2.356 7.25a1.6 1.6 0 0 1-2.644.645l-6.072-5.98ZM46.126 13.393c-1.17.607-2.532-.382-2.316-1.683l1.397-8.407a1.6 1.6 0 0 1 2.519-1.032l6.166 4.48a1.6 1.6 0 0 1-.203 2.715l-7.563 3.927ZM20.19 11.71c.216 1.3-1.145 2.29-2.316 1.682l-7.563-3.926a1.6 1.6 0 0 1-.203-2.714l6.166-4.48a1.6 1.6 0 0 1 2.519 1.031l1.397 8.407ZM10.575 37.457c1.304.196 1.824 1.796.885 2.722l-6.072 5.98a1.6 1.6 0 0 1-2.644-.646l-2.356-7.25a1.6 1.6 0 0 1 1.76-2.076l8.427 1.27Z"
    />
  </svg>
)
